module.exports = __webpack_public_path__ + "static/media/template-banner-small@2x.a2cd23a6.png";